(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-two"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-clt2-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-clt2-track]');
    var slides = slider.querySelectorAll('.clt2-slide');
    if (!track || slides.length === 0) return;

    var index = 0;
    var visible = parseInt(getComputedStyle(slider).getPropertyValue('--clt2-columns-desktop')) || 4;

    function getVisible() {
      var width = window.innerWidth;
      var v = width >= 750
        ? getComputedStyle(slider).getPropertyValue('--clt2-columns-desktop')
        : getComputedStyle(slider).getPropertyValue('--clt2-columns-mobile');
      return parseInt(v) || 1;
    }

    function update() {
      visible = getVisible();
      var maxIndex = Math.max(slides.length - visible, 0);
      if (index > maxIndex) index = maxIndex;
      if (index < 0) index = 0;
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = 16;
      track.style.transform = 'translateX(-' + (index * (slideWidth + gap)) + 'px)';
    }

    var prevBtn = slider.parentElement.querySelector('.clt2-nav-btn--prev');
    var nextBtn = slider.parentElement.querySelector('.clt2-nav-btn--next');

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var maxIndex = Math.max(slides.length - getVisible(), 0);
        index = Math.min(index + 1, maxIndex);
        update();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        index = Math.max(index - 1, 0);
        update();
      });
    }

    window.addEventListener('resize', update);
    update();

    if (slider.dataset.autoplay === 'true') {
      var speed = (parseFloat(slider.dataset.autoplaySpeed) || 3) * 1000;
      setInterval(function () {
        var maxIndex = Math.max(slides.length - getVisible(), 0);
        index = index >= maxIndex ? 0 : index + 1;
        update();
      }, speed);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300));
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
